import { ReactComponent as ShieldCheck } from '../../../assets/icons/shield-check.svg'
import { ReactComponent as Warning } from '../../../assets/icons/warning.svg'

export const DISABLED = 'disabled'
export const ENABLED = 'enabled'
export const SUCCESS = 'success'
export const ERROR = 'error'

export const STATUS = { DISABLED, ENABLED, SUCCESS, ERROR }

export const ICONS = {
  [ERROR]: <Warning />,
  [SUCCESS]: <ShieldCheck />,
}
